/**
 * O disparo de campanha pelo WhatsApp: as regras que valem nas duas pontas.
 *
 * O banco cobra de novo (`enfileirar_campanha`, migração `0073`); aqui ficam
 * para a tela recusar antes de ir ao servidor e para a demonstração se portar
 * como ele. A personalização é a mesma do agendador
 * (`supabase/functions/_compartilhado/agendador.ts`), e o teste compara as duas.
 */

export const LIMITE_DO_DISPARO = 500;
export const MENSAGEM_MINIMA = 10;
export const MENSAGEM_MAXIMA = 1000;

export interface ResultadoDoDisparo {
    enfileirados: number;
    jaNaFila: number;
    semTelefone: number;
    semConsentimento: number;
    foraDaClinica: number;
}

export function problemaDaMensagemDaCampanha(texto: string): string | null {
    const t = texto.trim();
    if (t.length < MENSAGEM_MINIMA) return 'Escreva a mensagem da campanha.';
    if (t.length > MENSAGEM_MAXIMA) return `A mensagem passa de ${MENSAGEM_MAXIMA} caracteres.`;
    return null;
}

/** `{nome}` vira o primeiro nome; sem nome, o marcador sai sem deixar vírgula sobrando. */
export function personalizar(texto: string, nome: string | null | undefined): string {
    const primeiro = (nome ?? '').trim().split(/\s+/)[0] ?? '';
    if (!primeiro) return texto.replace(/,\s*\{nome\}/g, '').replace(/\{nome\}\s*/g, '');
    return texto.replace(/\{nome\}/g, primeiro);
}

export function lerResultadoDoDisparo(bruto: unknown): ResultadoDoDisparo {
    const r = (bruto ?? {}) as Partial<Record<keyof ResultadoDoDisparo, unknown>>;
    return {
        enfileirados: Number(r.enfileirados ?? 0),
        jaNaFila: Number(r.jaNaFila ?? 0),
        semTelefone: Number(r.semTelefone ?? 0),
        semConsentimento: Number(r.semConsentimento ?? 0),
        foraDaClinica: Number(r.foraDaClinica ?? 0),
    };
}

/** O que aconteceu, em uma frase: quantos entraram na fila e quantos ficaram de fora, e por quê. */
export function resumoDoDisparo(r: ResultadoDoDisparo): string {
    const partes = [`${r.enfileirados} ${r.enfileirados === 1 ? 'pessoa entrou' : 'pessoas entraram'} na fila`];
    if (r.jaNaFila) partes.push(`${r.jaNaFila} já tinham recebido esta campanha`);
    if (r.semTelefone) partes.push(`${r.semTelefone} sem telefone completo`);
    if (r.semConsentimento) partes.push(`${r.semConsentimento} pediram outro canal`);
    if (r.foraDaClinica) partes.push(`${r.foraDaClinica} não são mais contatos ativos`);
    return `${partes.join(' · ')}.`;
}
